// extracted by mini-css-extract-plugin
export default {"button":"edit-column_button__bjAEH"};